<template>
  <q-page>
    <div class="q-pa-md">
      <Breadcrumbs path-name="purchase" path-method="purchaseOfflineList" />
      <div class="row justify-end q-mb-xs q-gutter-xs">
        <div class="col col-1">
          <q-btn
            v-if="purchaseCheckSetting"
            color="brown"
            icon="https"
            label="審核採購"
            stack
            @click="showPurchaseCheck = true"
          />
        </div>
        <div class="col col-3">
          <q-select
            filled
            v-model="search.year"
            :options="yearList"
            option-value="id"
            option-label="title"
            emit-value
            map-options
            @input="handleYearSelect"
            label="年度篩選">
            <template v-if="search.year && false" v-slot:append>
              <q-icon name="cancel" @click.stop="search.year = '', purchaseGetLocalList(search)" class="cursor-pointer" />
            </template>
          </q-select>
        </div>
      </div>
      <q-table
        title=""
        :data="purchaseList"
        :columns="columns"
        row-key="name"
        :pagination.sync="tableSet"
      >
        <template v-slot:top="props">
          <div class="col-3 q-table__title">{{ routerInfo.title }}</div>
          <router-link :to="'/purchase/offline-create'">
            <q-btn
              v-if="loginUser.permission && loginUser.permission.Purchase > 1"
              color="green"
              icon="create"
              label="新增本地採購單"
              style="right: 11px; top:5px; position: absolute;"
            />
          </router-link>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="status" :props="props">{{ purchaseStatus[props.row.status] }}</q-td>
            <!-- <q-td key="answerStatus" :props="props">{{ (props.row.PurchaseList.length >0)? "Yes": "No" }}</q-td> -->
            <!--<q-td key="no" :props="props">{{ props.row.inquiry_no }}</q-td>-->
            <q-td key="purchaseNo" :props="props">{{ props.row.purchase_no }}</q-td>
            <q-td key="note" :props="props">{{ props.row.note }}</q-td>
            <q-td key="totalBuy" :props="props">{{ props.row.totalBuy }}</q-td>
            <q-td key="supplierTitle" :props="props">{{ props.row.supplierTitle }}</q-td>
            <q-td key="time" :props="props">{{ props.row.created_at }}</q-td>
            <q-td key="action" :props="props">
              <router-link target="_blank" id="triggerBtn" :to="'/purchase/offline-edit/'+props.row.id">
                <q-btn
                  color="blue"
                  icon="description"
                  label="編輯"
                />
              </router-link>
              <q-btn 
                v-if="(loginUser.permission && loginUser.permission.Purchase === 4) && props.row.status === 1" 
                color="deep-orange" 
                icon="paid" 
                label="付款" 
                @click="handlePayListShow(props.row.id)" 
                class="q-ml-sm"
              /> 
              <q-btn
                color="green"
                icon="style"
                style="margin-left: 5px;"
                label="複製"
                @click="handleCopyPurchase(props.row)"
              />
              <q-btn
                v-if="handleSaveBtnCanShow(props.row)"
                color="red"
                icon="delete"
                style="margin-left: 5px;"
                @click="handleDataDelete(props.row.id)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <q-dialog  v-model="showPayList" persistent>
      <PurchasePayList />
    </q-dialog>
    <q-dialog  v-model="showPurchaseCheck" >
      <PurchaseCheckList :handle-row-click-event="handleCheckListClickDetail"/>
    </q-dialog>
    <q-dialog v-model="showPurchaseCheckDetail" persistent>
      <PurchaseCheckDetail :handle-click-return-event="handleCheckDetailReturnList" />
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import PurchasePayList from './components/PayList'
  import PurchaseCheckList from "./components/PurchaseCheckList"
  import PurchaseCheckDetail from "./components/PurchaseCheckDetail"
  export default {
    name: "PurchaseOffline",
    components: { Breadcrumbs, PurchasePayList, PurchaseCheckList, PurchaseCheckDetail },
    data() {
      return {
        showPayList: false,
        showPurchaseCheck: false,
        showPurchaseCheckDetail : false,
        purchaseCheckSetting: false,
        columns: [
          { name: 'status', align: 'center', label: '狀態', field: 'status', sortable: true,},
          // { name: 'answerStatus', align: 'center', label: '廠商回應', field: 'status', sortable: true,},
          { name: 'purchaseNo', align: 'center', label: '採購單編號', field: 'account', sortable: true },
          { name: 'note', align: 'center', label: '備註', field: 'note' },
          { name: 'totalBuy', align: 'center', label: '總採購數量', field: 'totalBuy' },
          { name: 'supplierTitle', align: 'center', label: '供應商', field: 'supplierTitle' },
          { name: 'time', label: '建立時間', field: 'nick_name', sortable: true },
          { name: 'action', label: '操作', align: 'center', field: 'id' }
        ],
        yearList: [],
        search: {
          year: "",
          patient_id: ""
        },
        tableSet: {
          sortBy: 'desc',
          descending: false,
          page: 1,
          rowsPerPage: 15
        }
      }
    },
    computed: {
      ...mapGetters(['purchaseList', 'routerInfo', 'purchaseStatus', 'loginUser', "settingList"])
    },
    created() {
      let checkQuery = window.location.hash.split("?")

      if(checkQuery.length  === 2) {
        let checkID = checkQuery[1].replace("check_id=", "")
        this.handleCheckListClickDetail({ id: checkID })
      }
      
      this.$store.dispatch('purchaseGetLocalList', this.search).then(res => {
        this.setYearList(res.Years)
        let find = this.settingList.find( r => r.action === "PurchaseNeedCheck")
        this.purchaseCheckSetting = (find.value === "1")? true : false
      })
    },
    methods: {
      handleDataDelete(id) {
        this.$q.dialog({
          dark: true,
          title: '確認！',
          message: '是否確定要刪除此本地採購單？',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.$store.dispatch('purchaseDelete', id)
        })

      },
      handleSaveBtnCanShow(row) {
        if (row.status === 0) {
          if (this.loginUser.permission.Purchase === 4) {
            return true
          }else {
            return false
          }
        }else {
          return false
        }

      },
      handleCopyPurchase(purchase) {
        this.$q.dialog({
          dark: true,
          title: '確認!',
          message: '是否確定要複製此本地採購單?',
          cancel: true,
          persistent: true
        }).onOk(() => {
          // this.$store.dispatch('purchaseDelete', id)
          purchase.PurchaseList.map(p =>{
            let data = {
              id: p.product_id,
              StockBlock: [],
              purchaseStock: p.buy,
              is_local: "1"
            }
            this.$store.dispatch('suggestAdd', data)
          })
          // GoPageAndReload(`/purchase/offline-create`)
          this.$router.push({
            path: `/purchase/offline-create`
          })
        })
      },
      handleYearSelect() {
        this.$store.dispatch('purchaseGetLocalList', this.search)
      },
      setYearList(res) {
        res.map((y, index) => {
          if (y.created_at) {
            let date = y.created_at.split("T")
            if (date) {
              let s = date[0].split("-")
              if (s[0] !== "0001") {
                this.yearList.push({
                  "id": s[0],
                  "title": s[0],
                })
              }
              if (index === 0) {
                this.search.year = s[0]
              }
            }
          }

        })
      },
      handlePayListShow(id) {
        this.showPayList = true
        this.$store.dispatch('purchaseSetPayID', id)
      },
      handleCheckListClickDetail(row) {
        this.$store.dispatch("purchaseGetCheckDetail", row.id)
          .then(res => {
            this.showPurchaseCheck = false
            this.showPurchaseCheckDetail = true
          })
      },
      handleCheckDetailReturnList() {
        this.showPurchaseCheckDetail = false
        this.showPurchaseCheck = true
      },
      ...mapActions(['purchaseGetLocalList'])
    }
  }
</script>
